import { LightBulbIcon, ChartBarIcon, BoltIcon } from '@heroicons/react/24/outline';
import { Target, MessageSquareQuote, Brain } from "lucide-react";

const Features = () => {
  return (
    <div className="space-y-32 max-w-7xl mx-auto px-4">

      <section className="text-center">
        <h2 className="text-[2.75rem] font-averia-bold mb-12 tracking-tight">From Passive Listening to Active Opportunity</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="bg-[#E8EDED] rounded-2xl p-8 aspect-square flex flex-col items-center justify-center">
            <div className="flex items-center justify-center w-16 h-16 bg-white/80 rounded-xl mb-6">
              <LightBulbIcon className="w-8 h-8 text-gray-700" />
            </div>
            <h3 className="text-2xl font-averia-bold mb-4">Conversational Search</h3>
            <p className="text-gray-600 leading-relaxed max-w-xs">
              Forget Ctrl+F. Ask natural language questions like 'What is the best marketing strategy mentioned in this episode?' and get instant, intelligent answers.
            </p>
            {/* <div className="p-3 mt-4 bg-gray-50 rounded">
              <p className="text-sm text-gray-500">
                "TalkToPods found a brilliant marketplace idea in a 3-hour podcast that I completely missed!"
              </p>
              <p className="mt-1 text-sm font-medium">- Harry, SME Founder (Omkars Friend)</p>
            </div> */}
          </div>

          <div className="bg-[#E8D9D9] rounded-2xl p-8 aspect-square flex flex-col items-center justify-center">
            <div className="flex items-center justify-center w-16 h-16 bg-white/80 rounded-xl mb-6">
              <ChartBarIcon className="w-8 h-8 text-gray-700" />
            </div>
            <h3 className="text-2xl font-averia-bold mb-4">Instant Summaries</h3>
            <p className="text-gray-600 leading-relaxed max-w-xs">
              Get concise summaries, key takeaways, and action items from hour-long episodes in seconds. Review the highlights without the fluff.
            </p>
            {/* <div className="p-3 mt-4 bg-gray-50 rounded">
              <p className="text-sm text-gray-500">
                "The market size estimates helped me prioritize which ideas to pursue first."
              </p>
              <p className="mt-1 text-sm font-medium">- Claude, Omkar's coding buddy</p>
            </div> */}
          </div>


          <div className="bg-[#DCD9E8] rounded-2xl p-8 aspect-square flex flex-col items-center justify-center">
            <div className="flex items-center justify-center w-16 h-16 bg-white/80 rounded-xl mb-6">
              <BoltIcon className="w-8 h-8 text-gray-700" />
            </div>
            <h3 className="text-2xl font-averia-bold mb-4">Unlock the Knowledge Base</h3>
            <p className="text-gray-600 leading-relaxed max-w-xs">
              Chat across the entire history of a podcast. Connect potential dots between an episode from 2021 and today to see how the host's thinking has evolved.
            </p>
            {/* <div className="p-3 mt-4 bg-gray-50 rounded">
              <p className="text-sm text-gray-500">
                "The implementation guide gives a clear picture of the idea. You can decide to put more time in it or not instantly"
              </p>
              <p className="mt-1 text-sm font-medium">- Sagar, Edtech Founder</p>
            </div> */}
          </div>

        </div>
        <div className="flex items-center justify-center mt-12">
          <a
            href="/podcasts"
            className="inline-flex items-center px-6 py-3 rounded-full bg-black text-white hover:opacity-90"
          >
            Explore Podcasts →
          </a>
        </div>
      </section>

      <section className="text-center">
        <h2 className="text-[2.75rem] font-averia-bold mb-12 tracking-tight">Bonus: The Podcast Gold Mine</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div className="bg-[#E8EDED] rounded-2xl p-8 aspect-square flex flex-col items-center justify-center">
            <div className="flex items-center justify-center w-16 h-16 bg-white/80 rounded-xl mb-6">
              <Target className="w-8 h-8 text-gray-700" />
            </div>
            <h3 className="text-2xl font-averia-bold mb-4">Products Mentioned</h3>
            <p className="text-gray-600 leading-relaxed max-w-xs">
              Discover the "side-mention" products that podcasters casually drop as their secret weapons. While everyone else is buying the sponsor's mattress, you'll be investing in that obscure productivity tool they mentioned in passing.
            </p>
          </div>

          <div className="bg-[#E8D9D9] rounded-2xl p-8 aspect-square flex flex-col items-center justify-center">
            <div className="flex items-center justify-center w-16 h-16 bg-white/80 rounded-xl mb-6">
              <MessageSquareQuote className="w-8 h-8 text-gray-700" />
            </div>
            <h3 className="text-2xl font-averia-bold mb-4">Quote Arsenal</h3>
            <p className="text-gray-600 leading-relaxed max-w-xs">
              Build your collection of "sounds-smart-at-parties" quotes that make you appear well-read, without the hassle of actually reading books. "As Tim Ferriss's neurosurgeon friend once said..." will become your new conversation starter.
            </p>
          </div>

          <div className="bg-[#DCD9E8] rounded-2xl p-8 aspect-square flex flex-col items-center justify-center">
            <div className="flex items-center justify-center w-16 h-16 bg-white/80 rounded-xl mb-6">
              <Brain className="w-8 h-8 text-gray-700" />
            </div>
            <h3 className="text-2xl font-averia-bold mb-4">Hidden Insights</h3>
            <p className="text-gray-600 leading-relaxed max-w-xs">
              Uncover the connections between guests across different podcasts that reveal emerging trends before they hit mainstream. It's like having business gossip, except it makes you money instead of enemies.
            </p>
          </div>

        </div>
      </section>

      {/* <div className="space-y-32">
              <section>
                <h2 className="text-[2.75rem] font-averia-bold mb-12 tracking-tight">The Reality Check</h2>
                <div className="space-y-6">
                  <div className="grid md:grid-cols-[1fr,auto] gap-8 items-center">
                    <div className="bg-[#e3b977] rounded-2xl p-8">
                      <h3 className="text-2xl font-averia-bold mb-6">Expectation</h3>
                      <p className="text-xl leading-relaxed">
                        You listen to a podcast → Your brain explodes with billion-dollar ideas → You become the next
                        Elon Musk (minus the Twitter drama)
                      </p>
                    </div>
                    <ScrollImage
                      src={expectation}
                      width={300}
                      height={200}
                      alt="Success illustration"
                      className="mx-auto md:sticky md:top-3 max-w-[250px] md:max-w-[300px]"
                    />
                  </div>
                  <div className="grid md:grid-cols-[auto,1fr] gap-8 items-center">
                    <ScrollImage
                      src={reality}
                      width={300}
                      height={200}
                      alt="Reality illustration"
                      className="mx-auto md:sticky md:top-3 max-w-[250px] md:max-w-[300px]"
                    />
                    <div className="bg-[#bab3cd] rounded-2xl p-8">
                      <h3 className="text-2xl font-averia-bold mb-6">Reality</h3>
                      <p className="text-xl leading-relaxed">
                        You listen to a podcast → Your brain explodes with billion-dollar ideas → You think 'I'll definitely remember this' → You absolutely don't remember this → You go back to doom scrolling while shoving pizza in your face → You remain decidedly un-billionaire-like
                      </p>
                    </div>
                  </div>
                </div>
              </section>

              <section>
                <h2 className="text-[2.75rem] font-averia-bold mb-12 tracking-tight">The Solution</h2>
                <div className="grid md:grid-cols-[1fr,auto] gap-8 items-start">
                  <div className="space-y-12">
                    <div className="bg-[#cb9ea3] rounded-2xl p-8">
                      <h3 className="text-2xl font-semibold mb-6">How we are fixing your podcast induced amnesia:</h3>
                      <div className="space-y-6">
                        <p className="text-xl leading-relaxed">
                           TalkToPods is like that friend who actually takes notes in class → It catches every brilliant idea → Transforms your podcast-induced fever dreams into actual business plans → Hands you a blueprint for world domination
                        </p>
                         <p className="text-xl leading-relaxed">
                          (But sorry, you still have to actually 'build' the thing. Its AI, not your Mom.)
                        </p>
                        <p className="text-xl leading-relaxed">
                        Look, I'm not promising these exact ideas will make you the next Silicon Valley wonder child.
                        But at least you'll graduate from 'I have no ideas' to 'I have TOO MANY ideas.'
                      </p>
                       <p className="text-xl leading-relaxed">
                        Stop edging with endless podcasts. Use TalkToPods to turn your mental masturbation into a
                        full-blown idea orgasm 🚀
                      </p>
                      </div>
                    </div>

                    
                  </div>

                </div>
              </section>
      </div> */}

    </div>
  );
};

export default Features;
